export enum CostAdditionalCodes {
    YmcePlExpense = 'Koszt YMCE-PL',
    Sale = 'Sprzedaż zwykła',
    Warehouse = 'Magazyn',
    Tests = 'Testy',
}

export const convertChecboxToCostAdditionalCodesArray = (checkboxes) => {
    return Object.keys(checkboxes)
        .filter(checkboxKey => checkboxes[checkboxKey])
        .map(checkboxKey => CostAdditionalCodes[checkboxKey]);
}

export const convertCostAdditionalCodesArrayToCheckbox = (additionalCodes: string[]) => {
    const additionalCodesCheckboxes = {};
    if (additionalCodes) {
        Object.keys(CostAdditionalCodes).map(costAdditionalCode => {
            let checked = false;
            checked = additionalCodes.some(additionalCode => additionalCode === CostAdditionalCodes[costAdditionalCode]);
            additionalCodesCheckboxes[costAdditionalCode] = checked;
        });
    }

    return additionalCodesCheckboxes;
}